import { getFederalHolidayInfo } from '../../utils/isFederalHoliday';

export const VONAGE_OUTAGE = {
  message:
    'Our phone system is temporarily unavailable due to a global Vonage outage. Service is expected to be restored within the next 90 minutes. We appreciate your patience.',
  severity: 'warning',
  dismissible: true,
  storageKey: 'vonageOutageWarning'
};

/**
 * Creates a federal holiday warning configuration.
 * @param {string} holidayName - The name of the federal holiday
 * @param {boolean} isAdvanceNotice - Whether this is advance notice (day before)
 * @returns {Object} Warning configuration object
 */
export const createFederalHolidayWarning = (holidayName, isAdvanceNotice = false) => {
  const message = isAdvanceNotice
    ? `Our offices will be closed tomorrow in observance of ${holidayName}. We will resume normal business hours on the following business day.`
    : `Our offices are closed today in observance of ${holidayName}. We will resume normal business hours on the next business day.`;

  return {
    message,
    severity: 'info',
    dismissible: true,
    storageKey: `federalHoliday_${holidayName.replace(/\s+/g, '_')}_${
      isAdvanceNotice ? 'advance' : 'today'
    }`
  };
};

/**
 * Gets the active warning to display.
 * Checks for federal holidays first, then falls back to manual warnings.
 * @returns {Object|null} The active warning configuration or null
 */
export const getActiveWarning = () => {
  const today = new Date();
  const holidayInfo = getFederalHolidayInfo(today);

  if (holidayInfo) {
    return createFederalHolidayWarning(holidayInfo.name, holidayInfo.isAdvanceNotice);
  }

  // Return null or a manual warning if needed
  // To enable a manual warning, uncomment the line below:
  // return VONAGE_OUTAGE;
  return null;
};

// For backwards compatibility
export const ACTIVE_WARNING = getActiveWarning();